import { Trans, useTranslation } from 'react-i18next'
import { cn } from 'src/utils/cx'
import IcBaselineAutoAwesome from '~icons/ic/baseline-auto-awesome'
import { useNavigateToGenerator } from '../hooks/useNavigateToGenerator'
import css from '../Landing.module.css'
import { useFadeUp } from './useFadeUp'

export default function FinalCTA() {
  const { t } = useTranslation('blackboard', { keyPrefix: 'welcome' })
  const fadeRef = useFadeUp()
  const navigateToGenerator = useNavigateToGenerator()

  return (
    <>
      <section
        id="final-cta"
        className="relative py-24 text-center"
        style={{
          background: 'linear-gradient(180deg, #fff, var(--landing-pink-bg))',
        }}
      >
        <div className="mx-auto max-w-[1200px] px-6">
          <div
            ref={fadeRef}
            className={cn(
              css.fadeUp,
              css.ctaGlow,
              'mx-auto max-w-[640px] rounded-[32px] border-2 border-[--landing-pink-light] bg-white/80 p-12',
            )}
          >
            <h2 className="mb-4 text-4xl font-black md:text-5xl">
              <Trans
                i18nKey="blackboard:welcome.final-cta.heading"
                components={{
                  highlight: <span className={css.gradientText} />,
                  br: <br />,
                }}
              />
            </h2>
            <p className="mb-9 text-base text-gray-500">
              {t('final-cta.subheading')}
            </p>
            <button
              onClick={() => navigateToGenerator()}
              className="inline-flex items-center gap-2 rounded-full bg-[--landing-pink] px-10 py-4 text-lg font-bold text-white shadow-[0_4px_16px_rgba(255,131,184,0.3)] transition-all hover:-translate-y-0.5 hover:bg-[--landing-pink-dark] hover:shadow-[0_8px_24px_rgba(255,131,184,0.4)]"
            >
              <IcBaselineAutoAwesome className="size-5" />{' '}
              {t('final-cta.button')}
            </button>
          </div>
        </div>
      </section>
    </>
  )
}
